import React from "react";
import { basename } from "../../../Config";

function Index() {
  return (
    <div className="noPageFound">
      <img src={`/${basename}/Assets/Images/SFLlogo.png`} alt="Logo" />
      <p>You don't have access to this feature!</p>
    </div>
  );
}

export default Index;
